import React, { useState } from 'react';
import ChangeOrUpdateSubscription from '~/components/page/Settings/Subscription/components/ChangeOrUpdateSubscription';
import useSessionHydration from '../useSessionHydration';
import type { UpgradeSourceType } from '~/components/organism/LimitUpgradeCTA/constants';
import useTrackEvent from '~/hooks/useTrackEvent';

type Args = {
  onComplete?: () => void;
  upgradeSource?: UpgradeSourceType;
};

const useOnUpgradeSubscription = ({ onComplete, upgradeSource }: Args) => {
  const [, refetchSessionHydration] = useSessionHydration();
  const [showModal, setShowModal] = useState(false);
  const hideModal = () => setShowModal(false);
  const trackEvent = useTrackEvent();

  return {
    onUpgrade: () => setShowModal(true),
    modal: showModal ? (
      <ChangeOrUpdateSubscription
        onClose={hideModal}
        onComplete={planId => {
          hideModal();
          if (onComplete) onComplete();

          /** ----- TRACKING: subscription_upgraded ----- */
          trackEvent({
            eventName: 'subscription_upgraded',
            parameters: {
              plan_id: planId,
              ...(upgradeSource && { upgrade_source: upgradeSource }),
            },
          });

          return refetchSessionHydration();
        }}
        accountIsSetup
      />
    ) : null,
  };
};

export default useOnUpgradeSubscription;
